<template>
  <div class="columns is-centered">
    <div class="column is-half">
      <ValidationObserver
        ref="observer"
        v-slot="{ pristine, invalid, passes }"
      >
        <form @submit.prevent="passes(updatePassword)">
          <div class="columns">
            <div class="column">
              <div class="field">
                <ValidationProvider
                  name="Password"
                  rules="required"
                  vid="password"
                  v-slot="{ errors }"
                >
                  <label class="label">New Password</label>
                  <div class="control has-icons-left">
                    <input
                      class="input"
                      :class="{ 'is-danger': errors.length }"
                      type="password"
                      placeholder="Password"
                      v-model="newPassword.password"
                    />
                    <span class="icon is-small is-left">
                      <i class="fas fa-lock"></i>
                    </span>
                  </div>
                  <p class="help is-danger" v-show="errors.length">
                    {{ errors[0] }}
                  </p>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <div class="field">
                <ValidationProvider
                  name="Password confirmation"
                  rules="required|confirmed:password"
                  v-slot="{ errors }"
                >
                  <label class="label">Confirm New Password</label>
                  <div class="control has-icons-left">
                    <input
                      class="input"
                      :class="{ 'is-danger': errors.length }"
                      type="password"
                      placeholder="Confirm Password"
                      v-model="newPassword.confirmPassword"
                    />
                    <span class="icon is-small is-left">
                      <i class="fas fa-lock"></i>
                    </span>
                  </div>
                  <p class="help is-danger" v-show="errors.length">
                    {{ errors[0] }}
                  </p>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-one-quarter">
              <div class="field">
                <input
                  :disabled="pristine || invalid || loading"
                  type="submit"
                  value="Change Password"
                  class="button is-primary"
                />
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
export default {
  name: 'PasswordForm',
  components: {
    ValidationObserver,
    ValidationProvider
  },
  props: [
    'userData'
  ],
  data() {
    return {
      loading: false,
      disable: false,
      newPassword: {
        password: '',
        confirmPassword: ''
      },
      user: this.userData || {}
    };
  },
  methods: {
    updatePassword() {
      this.loading = true;
      this.$axios
        .put(this.$API.updatePassword(this.user._id), this.newPassword)
        .then(() => {
          this.newPassword.password = '';
          this.newPassword.confirmPassword = '';
          this.$notify({
            group: 'alert',
            title: 'Success!',
            text: 'Successfully updated your password.',
            type: 'success'
          });
        })
        .catch(() => {
          this.$notify({
            group: 'alert',
            title: 'FAILED!',
            text: 'Something went wrong while updating your password.',
            type: 'error'
          });
        })
        .finally(() => (this.loading = false));
    }
  }
};
</script>
<style lang="scss" scoped>
figure {
  margin-left: auto;
  margin-right: auto;
}
.tabs {
  margin-top: 15px;
}
</style>